// @flow

import type { CompConfig } from '../type'

import * as React from 'react'
import Header from './ui/Header'
import NotSupport from './basic/NotSupport'
import {
  Text,
  Html,
  Folder,
  Image,
  Video,
  Float,
  RootMobile,
  RootPc,
  Fixed,
  Popup,
  Swiper,
  Highcharts,
  IScroll,
  Highstock,
  MarqueeLabel,
  Cropper,
  ROOT_ID,
  CountUp,
  QrCode,
  CopyText,
  WeixinAppButton,
  Iframe,
  Lottie
} from './basic'
import Marquee from './app/Marquee'
import {
  Form,
  FormInput,
  FormInputFile,
  FormSelect,
  FormTextarea,
  FormRichText,
  FormCheckbox,
  BjFormInputPwd,
  FormDateInput,
  FormChooseInput,
  OpenImg
} from './form'
import {
  CallApi,
  DataHandler,
  Iterator,
  Interval,
  Timeout,
  JsLogic,
  CustomProps,
  CustomPropsConfig,
  GetGeoLocation,
  SyncUserInfo,
  BeforeUnload,
} from './program'
import AppText from './app/AppText'
import {
  PoundEgg,
  RectZhuanPan,
  CircleZhuanPan,
  CardDraw,
  IncomeCalculator,
  ScrapingPrize
} from './ui'
import PcFullColumn from './pc/PcFullColumn'
import Complex from './complex/Complex'
import Toutiao from './plugin/Toutiao'
import Admob from './plugin/Admob'
import Inmobi from './plugin/Inmobi'
import NewInmobi from './plugin/NewInmobi'
import Yunyan from './plugin/Yunyan'
import Baidu from './plugin/Baidu'
import XqkdPboc from './plugin/XqkdPboc'
import ocpcboc from './plugin/Ocpc'

export const MobileRootConfig: CompConfig = {
  component: RootMobile,
  title: '页面根节点',
  id: ROOT_ID,
  props: {},
  type: 'root',
  icon: 'home'
}

export const PcRootConfig: CompConfig = {
  component: RootPc,
  title: '页面根节点',
  id: ROOT_ID,
  props: {},
  type: 'rootPc',
  icon: 'home'
}

export const basicComps: Array<CompConfig> = [
  {
    component: Folder,
    title: '容器',
    type: 'folder',
    icon: 'folder-o'
  },
  {
    component: Float,
    title: '浮动',
    type: 'float',
    icon: 'hand-paper-o',
    defaultProps: {
      style: {
        top: '20%',
        left: '20%',
        width: '50%',
        height: '50%',
        backgroundColor: 'rgba(245, 166, 35, 0.6)'
      }
    },
    platforms: ['h5', 'pc', 'miniPro', 'appNative']
  },
  {
    component: Popup,
    title: '弹窗',
    type: 'popup',
    icon: 'snowflake-o',
    defaultProps: {
      style: {
        top: 150,
        left: '20%',
        width: '60%',
        height: 300,
        backgroundColor: 'rgba(245, 166, 35, 0.6)'
      }
    }
  },
  {
    component: Image,
    title: '图片',
    type: 'image',
    icon: 'picture-o'
  },
  {
    component: Video,
    title: '视频',
    type: 'video',
    icon: 'file-video-o'
  },
  {
    component: Text,
    title: '文字',
    type: 'text',
    icon: 'file-text-o',
    platforms: ['h5', 'pc', 'miniPro', 'appNative']
  },
  {
    component: WeixinAppButton,
    title: '按钮',
    type: 'button',
    icon: 'square',
    platforms: ['miniPro']
  },
  {
    component: CopyText,
    title: '复制文字',
    type: 'copyText',
    icon: 'copy',
    platforms: ['h5', 'pc']
  },
  {
    component: AppText,
    title: '文字',
    type: 'appText',
    icon: 'file-text-o',
    platforms: ['app']
  },
  {
    component: Html,
    title: '富文本',
    type: 'html',
    icon: 'html5',
    defaultProps: {
      style: {
        paddingLeft: 10,
        paddingRight: 10
      }
    }
  },
  {
    component: Fixed,
    title: '固顶固底',
    type: 'fixed',
    icon: 'credit-card-alt'
  },
  {
    component: Swiper,
    title: '滑动组件',
    type: 'swiper',
    icon: 'hand-o-down'
  },
  {
    component: Lottie,
    title: 'lottie动画',
    type: 'lottie',
    icon: 'eercast'
  },
  {
    component: MarqueeLabel,
    title: '跑马灯组件',
    type: 'marqueeLabel',
    icon: 'hand-o-down'
  },
  {
    component: Highcharts,
    title: '图表',
    type: 'highcharts',
    icon: 'line-chart'
  },
  {
    component: Highstock,
    title: '股票图表',
    type: 'Highstock',
    icon: 'bar-chart'
  },
  {
    component: IScroll,
    title: '滚动刷新',
    type: 'iscroll',
    icon: 'arrows-v',
    platforms: ['h5']
  },
  {
    component: Cropper,
    title: '裁剪',
    type: 'cropper',
    icon: 'crop',
    platforms: ['h5']
  },
  {
    component: CountUp,
    title: '数字滚动',
    type: 'CountUp',
    icon: 'rocket'
  },
  {
    component: QrCode,
    title: '二维码',
    type: 'qrCode',
    icon: 'qrcode'
  },
  {
    component: Iframe,
    title: 'iframe',
    type: 'iframe',
    icon: 'folder-o'
  }
]

export const appComps: Array<CompConfig> = [
  {
    component: Marquee,
    title: '跑马灯',
    type: 'marquee',
    icon: 'lightbulb-o'
  }
]

export const formComps: Array<CompConfig> = [
  {
    component: Form,
    title: '表单',
    type: 'form',
    icon: 'square-o',
    platforms: ['h5', 'pc']
  },
  {
    component: BjFormInputPwd,
    title: '北京银行密码框',
    type: 'bjFormInputPwd',
    icon: 'bandcamp',
    platforms: ['h5']
  },
  {
    component: FormChooseInput,
    title: '选择框',
    type: 'formChooseInput',
    icon: 'bandcamp',
    platforms: ['h5']
  },
  {
    component: FormDateInput,
    title: '时间选择控件',
    type: 'formDateInput',
    icon: 'bandcamp',
    platforms: ['h5', 'pc']
  },
  {
    component: FormInput,
    title: '单行输入框',
    type: 'formInput',
    icon: 'edit',
    platforms: ['h5', 'pc']
  },
  {
    component: FormCheckbox,
    title: '复选框',
    type: 'formCheckbox',
    icon: 'dot-circle-o',
    platforms: ['h5', 'pc']
  },
  {
    component: FormSelect,
    title: '下拉选择框',
    type: 'formSelect',
    icon: 'dot-circle-o',
    defaultProps: {
      optionType: 'static'
    },
    platforms: ['h5', 'pc']
  },
  {
    component: FormTextarea,
    title: '多行文本框',
    type: 'formTextarea',
    icon: 'dot-circle-o',
    defaultProps: {
      optionType: 'static'
    },
    platforms: ['h5', 'pc']
  },
  {
    component: FormRichText,
    title: '富文本编辑',
    type: 'formRichText',
    icon: 'edit',
    defaultProps: {
      optionType: 'static'
    },
    platforms: ['h5', 'pc']
  },
  {
    component: OpenImg,
    title: '选择图片',
    type: 'openImg',
    icon: 'file-photo-o'
  },
  {
    component: FormInputFile,
    title: '选择图片(含ui)',
    type: 'formInputFile',
    icon: 'file-photo-o'
  }
]

export const programComps: Array<CompConfig> = [
  {
    component: CallApi,
    title: '调用 API',
    type: 'callApi',
    icon: 'send-o',
    defaultProps: {
      method: 'get'
    }
  },
  {
    component: DataHandler,
    title: '数据处理',
    type: 'dataHandler',
    icon: 'long-arrow-right'
  },
  {
    component: Iterator,
    title: '迭代器',
    type: 'iterator',
    icon: 'list'
  },
  {
    component: Interval,
    title: 'Interval',
    type: 'Interval',
    icon: 'clock-o'
  },
  {
    component: Timeout,
    title: 'Timeout',
    type: 'timeout',
    icon: 'clock-o'
  },
  {
    component: JsLogic,
    title: '逻辑处理',
    type: 'jsLogic',
    icon: 'code-fork',
    platforms: ['h5', 'pc']
  },
  {
    component: CustomProps,
    title: '属性传递',
    type: 'customProps',
    icon: 'pied-piper-pp'
  },
  {
    component: CustomPropsConfig,
    title: '属性配置',
    type: 'customPropsConfig',
    icon: 'pied-piper-pp'
  },
  {
    component: GetGeoLocation,
    title: '获取经纬度',
    type: 'getGeoLocation',
    icon: 'map-marker'
  },
  {
    component: SyncUserInfo,
    title: '同步用户信息',
    type: 'syncUserInfo',
    icon: 'user-o'
  },
  {
    component: BeforeUnload,
    title: 'BeforeUnload',
    type: 'beforeUnload',
    icon: 'send-o',
  }
]

export const uiComps: Array<CompConfig> = [
  {
    component: Header,
    title: '顶部标题栏',
    type: 'header',
    icon: 'header'
  },
  {
    component: RectZhuanPan,
    title: '方形转盘',
    type: 'rect',
    icon: 'compass',
    platforms: ['h5']
  },
  {
    component: PoundEgg,
    title: '砸蛋',
    type: 'egg',
    icon: 'compass',
    platforms: ['h5']
  },
  {
    component: CircleZhuanPan,
    title: '圆形转盘',
    type: 'circle',
    icon: 'compass',
    platforms: ['h5']
  },
  {
    component: CardDraw,
    title: '卡牌抽奖',
    type: 'card',
    icon: 'compass',
    platforms: ['h5']
  },
  {
    component: IncomeCalculator,
    title: '收入计算器',
    type: 'calculator',
    icon: 'compass',
    platforms: ['h5']
  },
  {
    component: ScrapingPrize,
    title: '刮刮乐抽奖',
    type: 'scrape',
    icon: 'compass',
    platforms: ['h5']
  }
]

export const pluginComps: Array<CompConfig> = [
  {
    component: Toutiao,
    title: '头条广告代码',
    type: 'toutiao'
  },
  {
    component: Admob,
    title: 'Admob 广告代码',
    type: 'admob'
  },
  {
    component: Inmobi,
    title: 'Inmobi 广告代码',
    type: 'inmobi'
  },
  {
    component: NewInmobi,
    title: 'NewInmobi 广告代码',
    type: 'newInmobi'
  },
  {
    component: Yunyan,
    title: '云眼广告代码',
    type: 'yunyan'
  },
  {
    component: Baidu,
    title: '百度统计代码',
    type: 'baidu'
  },
  {
    component: XqkdPboc,
    title: '征信相关代码',
    type: 'xqkdPboc'
  },
  {
    component: ocpcboc,
    title: 'OCPC相关代码',
    type: 'ocpcboc'
  }
]

export const pcFullColumnConfig: CompConfig = {
  component: PcFullColumn,
  title: 'PC 通栏',
  type: 'pcFullColumn',
  icon: 'tv'
}

const notSupportConfig: CompConfig = {
  component: NotSupport,
  title: '暂不支持',
  type: 'notSupport'
}

export const treeTypes: {
  [string]: { icon: string, component: React.ComponentType<*> }
} = {}

const allComps: Array<CompConfig> = [
  MobileRootConfig,
  PcRootConfig,
  ...basicComps,
  ...appComps,
  ...formComps,
  ...programComps,
  ...uiComps,
  ...pluginComps,
  pcFullColumnConfig,
  notSupportConfig,
  {
    component: Complex,
    title: '复杂组件',
    type: 'complex',
    icon: 'futbol-o'
  }
]

allComps.forEach((comp: CompConfig) => {
  treeTypes[comp.type] = {
    icon: 'fa fa-' + (comp.icon || 'leaf'),
    component: comp.component
  }
})



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/comps.js